import {
  authorizeDeleteRequest,
  authorizeGetRequest,
  authorizePatchRequest,
  authorizePostRequest,
} from "api";
import { IApiResponse, IPaginatedResponse } from "models";
import { ICity, ICityInput } from "models/city";

export const citiesApi = (page: number, perPage: number, search: string) => {
  return authorizeGetRequest<IPaginatedResponse<ICity>>(
    `cities?page=${page}&per_page=${perPage}&query=${search}`
  );
};

export const createCityApi = (data: ICityInput) => {
  return authorizePostRequest<IApiResponse<ICity>>("cities", data);
};

export const updateCityApi = (id: string, data: ICityInput) => {
  return authorizePatchRequest<IApiResponse<ICity>>(`cities/${id}`, data);
};

export const deleteCityApi = (id: string) => {
  return authorizeDeleteRequest<IApiResponse<ICity>>(`cities/${id}`);
};

export const fetchCityByIdApi = (id: string) => {
  return authorizeGetRequest<IApiResponse<ICity>>(`cities/${id}`);
};
